import _extends from "@babel/runtime/helpers/extends";
import { useFocusMode } from "@smartsheet/lodestar-core";
import React, { forwardRef, useCallback } from "react";
import { ToastLinkOverflow } from "../styled/ToastLinkOverflow";
import { ToastLinkStyled } from "../styled/ToastLinkStyled";
export const ToastLink = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    children,
    clientId,
    isDisabled,
    onClick: providedOnClick,
    onDoubleClick: providedOnDoubleClick,
    onKeyPress: providedOnKeyPress,
    ...rest
  } = _ref;
  const onClick = useCallback(e => {
    if (isDisabled) {
      e.preventDefault();
      return;
    }
    if (providedOnClick) {
      providedOnClick(e);
    }
  }, [isDisabled, providedOnClick]);
  const onDoubleClick = useCallback(e => {
    if (isDisabled) {
      e.preventDefault();
      return;
    }
    if (providedOnDoubleClick) {
      providedOnDoubleClick(e);
    }
  }, [isDisabled, providedOnDoubleClick]);
  const onKeyPress = useCallback(e => {
    if (e.key === "Enter" || e.key === " ") {
      onClick(e);
    }
    if (providedOnKeyPress) {
      providedOnKeyPress(e);
    }
  }, [onClick, providedOnKeyPress]);
  const {
    focusMode
  } = useFocusMode();
  return /*#__PURE__*/React.createElement(ToastLinkStyled, _extends({
    focusMode: focusMode,
    tabIndex: 0,
    "aria-disabled": isDisabled,
    onClick: onClick,
    onKeyPress: onKeyPress,
    onDoubleClick: onDoubleClick,
    "data-client-id": clientId
    // These are always hidden because Toasts aren't screen-reader friendly. See the
    // Toast docs for more.
    ,
    "aria-hidden": true
  }, rest, {
    ref: ref
  }), /*#__PURE__*/React.createElement(ToastLinkOverflow, null, children));
});
ToastLink.displayName = "ToastLink";
//# sourceMappingURL=ToastLink.js.map